export const createGameActionBoxSlice = ()=>(set, get)=>({
            actionBox: {
                actionBoxData: undefined,
                setActionBoxData: (data)=>set({
                        actionBox: {
                            ...get().actionBox,
                            actionBoxData: data
                        }
                    }),
                hideActionBox: ()=>set({
                        actionBox: {
                            ...get().actionBox,
                            actionBoxData: undefined
                        }
                    })
            }
        });
